import React from 'react';
import './style.scss';

export const UserManageHeader = () => {
  return (
    <>
      <div className="subUserHeader">
        <span className="subUserHeader_id">利用者番号</span>
        <span className="subUserHeader_email">メールアドレス</span>
        <span className="subUserHeader_delete">利用者削除</span>
      </div>
    </>
  );
};
